import { useAuth } from '../auth/AuthProvider';
import CarOwnerDashboard from './CarOwnerDashboard';
import MechanicHome from './MechanicHome';

export default function DashboardRouter() {
  const { user } = useAuth();

  if (user?.user_type === 'mechanic') return <MechanicHome />;
  return <CarOwnerDashboard />;
}
